import React from 'react'
import { Icon } from 'labguard-cdk'

export default function DeviationIcon(props) {
  return (
    <Icon {...props}>
      <i>σ</i>
    </Icon>
  )
}
